import { render, staticRenderFns } from "./StorePoster.vue?vue&type=template&id=095ad2b4&scoped=true"
import script from "./StorePoster.vue?vue&type=script&lang=js"
export * from "./StorePoster.vue?vue&type=script&lang=js"
import style0 from "./StorePoster.vue?vue&type=style&index=0&id=095ad2b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095ad2b4",
  null
  
)

export default component.exports